import * as React from 'react';

import { TOfferGeo, IAddress } from '../../../types/offer';

const getAddressString = (address: IAddress[]) =>
  address
    .map(a => a.shortName)
    .join(', ')
    .trim();

export const useAddress = (geo?: TOfferGeo | null): string => {
  const formatAddress = React.useMemo(() => {
    if (!geo) {
      return '';
    }
    const { address } = geo;

    return address ? getAddressString(address.slice(1)) + ', ' + address[0].shortName : '';
  }, [geo]);

  return formatAddress;
};
